import CloseIcon from '@mui/icons-material/Close'
import { Button, Modal, Box } from '@mui/material'
import { Link } from 'react-router-dom'
import * as css from './styles'
import { useDatasetDataContext } from '../../../datasetData/context'
import { t } from '@lingui/core/macro'

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 960,
  fontSize: 14,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  p: 2,
}

interface ConfirmEditModalProps {
  open: boolean
  onClose: () => void
  onContinue: () => void
}

export function ConfirmEditModal({ open, onContinue, onClose }: ConfirmEditModalProps) {
  const { datasetTemplateId } = useDatasetDataContext()

  return (
    <Modal open={open} data-testid="confirm-edit-modal">
      <Box sx={style} data-testid="confirm-edit-modal-container">
        <css.CloseIcon>
          <CloseIcon
            onClick={onClose}
            sx={{ color: '#757675', cursor: 'pointer' }}
            data-testid="close-icon"
          />
        </css.CloseIcon>
        <h1 style={{ fontSize: 20, marginTop: 0 }}>{t`Warning: Risk of overwrite`}</h1>
        <p>
          {t`One or more rows of data from this submission have been altered. Proceeding to update will replace the most recent changes. Are you sure you want to continue?`}
        </p>
        <div style={{ display: 'flex', gap: 10, width: '100%', justifyContent: 'flex-end' }}>
          <Button
            color="primary"
            variant="outlined"
            size="small"
            style={{ padding: '2px 10px', fontSize: 14, fontWeight: 500 }}
            onClick={onContinue}
            data-testid="edit-modal-continue-button"
          >
            {t`Continue`}
          </Button>
          <Link to={`/template/${datasetTemplateId}/data`} data-testid="template-link">
            <Button
              color="primary"
              variant="contained"
              size="small"
              style={{ padding: '2px 10px', fontSize: 14, fontWeight: 500 }}
              data-testid="edit-modal-view-dataset-button"
            >
              {t`View dataset`}
            </Button>
          </Link>
        </div>
      </Box>
    </Modal>
  )
}
